export const selectSpecificFormSettingSelector = (state, settingName) => {
    const settingToFind = settingName;

    return state.formSettings[settingToFind];
};

export const selectInjectionDataSelector = (state, dataLocation) => {
    const {
        formSettings: {
            theme: { add_header = "", add_footer = "", pageSpecificSettings },
        },
    } = state;

    const { currentPage } = state;

    const pageSpecificContent =
        currentPage &&
        pageSpecificSettings &&
        Object.keys(pageSpecificSettings[currentPage]).length > 0
            ? pageSpecificSettings[currentPage]
            : {};

    const getContent = () => {
        const pageHeader = pageSpecificContent.add_header;

        const headerContent = pageHeader ? add_header + pageHeader : add_header;

        const pageFooter = pageSpecificContent.add_footer;

        const footerContent = pageFooter ? add_footer + pageFooter : add_footer;

        if (dataLocation === "header") return headerContent;

        if (dataLocation === "footer") return footerContent;

        return null;
    };

    return getContent(dataLocation);
};
